export const HEADER_TABS = [
    "Home", "Health A-Z", "Log in"
];
